import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=review")
      .then(res => res.json())
      .then(setReviews)
      .catch(() => setReviews([]));
  }, []);

  return (
    <div className="d-flex justify-content-center mt-4">
      <div className="row w-100" style={{ maxWidth: 1200 }}>
        <div className="w-100 mb-4">
          <div className="p-3 shadow rounded bg-white floating-box h-100">
            <div
              className="text-center mb-3 p-2 rounded fw-bold"
              style={{ backgroundColor: "#f0f5ff", color: "#003366" }}
            >
              Reviews
            </div>

            {reviews.length === 0 ? (
              <p>No reviews found</p>
            ) : (
              reviews
                .filter(r => r.type === "review")
                .map((r) => (
                  <Link
                    to={`/article/${r._id}`}
                    key={r._id}
                    className="text-decoration-none"
                  >
                    <div className="card mb-2 p-2 article-card">
                      <h6 className="mb-1 fw-bold">{r.title}</h6>
                      <p className="mb-0 text-muted">
                        {r.content.slice(0, 120)}...
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews;
